import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { withStyles } from "@material-ui/core/styles";
import DocumentSidebar from "./document/DocumentSidebar";
import Mark from "mark.js";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import DisplayTemplate from "./content/DisplayTemplate";
import { setCustomFields } from "../redux/actions/customFieldsActions";
import PDFViewer from "./PDFViewer";
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import CloseIcon from "@material-ui/icons/Close";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Alert from "@material-ui/lab/Alert";
import LinearProgress from "@material-ui/core/LinearProgress";
import PropertyNames from "../PropertyNames";
import { withSnackbar } from "notistack";
import Drawer from "@material-ui/core/Drawer";
import classNames from "classnames";
import { isExcelMime, isWordMime, isPptMime } from "./content/MimeTypeHelper";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import SwipeableViews from "react-swipeable-views";
import PubSub from "pubsub-js";
import Collapse from "@material-ui/core/Collapse";
import { Trans, withTranslation } from "react-i18next";

import Badge from "@material-ui/core/Badge";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { AutoSizer } from "react-virtualized";
import CreateContentFlow from "./content/CreateContentFlow";
import axios, { contentClient } from "../AxiosClient";
import { EDIT_SELECTED } from "../utils/Topics";
import DiffRevisions from "./content/DiffRevisions";
import { withRouter } from "react-router";
import moment from "moment";
import Switch from "@material-ui/core/Switch";
import KpsTextField from "./KpsTextField";
const drawerWidth = 300;
const SHOW_REVALIDATION_WARNING = 1;
const styles = (theme) => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
    marginTop: 5,
  },
  container: {
    display: "flex",
    width: "100%",
    height: "100%",
  },
  documentContainer: {
    flex: 70,
    height: "100%",
    "& > div .page": {
      marginLeft: "auto",
      marginRight: "auto",
    },
    overflow: "auto",
  },
  documentContainerNoOverflow: {
    flex: 70,
    height: "100%",
    "& > div .page": {
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  sidebarContainer: {
    borderRight: "1px solid rgba(0, 0, 0, 0.12)",
  },
  srOnly: {
    position: "absolute",
    left: "-10000px",
    width: "1px",
    height: "1px",
    overflow: "hidden",
  },
  fragmentContainer: {
    borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
  },
  pageContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    minHeight: 0,
  },
  iframe: {
    borderWidth: 0,
    width: "100%",
    height: 700,
  },
  pdfViewerToolbar: {
    textAlign: "center",
    width: "500px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  button: {
    margin: theme.spacing(1),
  },
  textLayer: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: "auto",
    opacity: 0.4,
    lineHeight: 1.0,
    "& > span": {
      position: "absolute",
      color: "transparent",
      whiteSpace: "pre",
      cursor: "text",
      transformOrigin: "0% 0%",
    },
    "& > span.highlight": {
      backgroundColor: "yellow",
    },
    "& > span.highlight mark": {
      backgroundColor: "yellow",
      color: "transparent",
    },
    "& > span > span.highlight": {
      backgroundColor: "yellow",
    },
    "& mark": {
      backgroundColor: "yellow",
      color: "transparent",
    },
  },
  annotationLayer: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    overflow: "hidden",
    opacity: 0.2,
    lineHeight: 1.0,
    "& > section": {
      position: "absolute",
      color: "transparent",
      whiteSpace: "pre",
      cursor: "text",
      transformOrigin: "0% 0%",
    },
    "& > * > a": {
      position: "absolute",
      fontSize: "1em",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
    },
  },
  zoomButton: {
    marginLeft: "2px",
    marginRight: "2px",
  },
  searchButton: {
    marginLeft: "2px",
    marginRight: "2px",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  downloadedCover: {
    position: "absolute",
    height: "100%",
    width: "100%",
    zIndex: 2000,
    backgroundColor: theme.palette.common.white,
    display: "none",
    alignItems: "center",
    flexDirection: "column",
    paddingTop: 50,
  },
  showDownloadCover: {
    display: "flex",
  },
  noSelectSpan: {
    userSelect: "none",
  },
  drawer: {
    width: drawerWidth,
    zIndex: 1,
    // flexShrink: 0,
    // whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    position: "relative",
    overflowX: "hidden",
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(6) + 1,
    "& #sidebarContent": {
      display: "none",
    },
    position: "relative",
  },
  expansionPanel: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    flexDirection: "column",
  },
  matchToolbar: {
    textAlign: "center",
    marginLeft: "auto",
    marginRight: "auto",
  },
  button: {
    marginLeft: "2px",
    marginRight: "2px",
  },
  margin: {
    margin: theme.spacing(2),
    marginRight: theme.spacing(3),
  },
  searchHistoryControl: {
    textAlign: "center",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  radioGroup: {
    display: "inline",
  },
  dragArea: {
    position: "absolute",
    zIndex: 98,
    width: "100%",
    visibility: "hidden",
  },
});
function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}
export class DocumentViewer extends Component {
  constructor(props) {
    super(props);
    this.getPrevMatch = this.getPrevMatch.bind(this);
    this.getNextMatch = this.getNextMatch.bind(this);
    this.getFirstMatch = this.getFirstMatch.bind(this);
    this.getLastMatch = this.getLastMatch.bind(this);
    this.getDocumentSearchHistory = this.getDocumentSearchHistory.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateSection = this.updateSection.bind(this);
    this.pdfViewer = React.createRef();
  }
  static propTypes = {
    fragments: PropTypes.array,
    documentId: PropTypes.number.isRequired,
    isSearch: PropTypes.bool,
    pdfIsRendering: PropTypes.bool,
    pdfScale: PropTypes.number,
    progress: PropTypes.number,
    loading: PropTypes.bool,
    searchMatches: PropTypes.number,
    currentSearchMatch: PropTypes.number,
    searchId: PropTypes.any,
    trackingId: PropTypes.number,
    documentSearchHistoryResults: PropTypes.array,
    showMine: PropTypes.bool,
    historymessagecount: PropTypes.number,
  };

  state = {
    customFields:[],
    sidebarOpen: !this.props.isMobile ? true : false,
    docContent: "",
    docType: "text/html",
    pdfScale: 150,
    pdfFindController: null,
    pdfViewer: null,
    pdfMatches: [],
    pdfPageUpdate: false,
    progress: 0,
    loading: true,
    searchMatches: 0,
    expandedMatchPanel: "fragments",
    currentSearchMatch: 0,
    trackingId: 0,
    documentSearchHistoryResults: [],
    showMine: true,
    historymessagecount: 0,
    selected: 0,
    instance: new Date().getTime().toString(),
    contentRevision: {},
    template: {},
    edit: false,
    internalDocument: null,
    editRevision: null,
    draft: false,
    diff: false,
    diffRevisionNumber: null,
    diffNodes: [],
    diffRecent: false,
    resolvingReworks: [],
    pdfFindFunction: null,
    pdfNextMatchFunction: null,
    pdfPreviousMatchFunction: null,
    displayAs: "pdf",
    error: false,
    showRevalMessage: false,
    forbidden: false,
    downloadedOriginal: false,
    keepSidebarOnReload: false,
    PDFViewerSearchString: null,
    previousMatch: 0,
    nextMatch: 0,
  };

  searchDebounce = null;

  componentDidUpdate(prevProps, prevState) {
    if (this.props.documentId !== prevProps.documentId) {
      this.getDocumentContent();
    }
    if (
      this.props.documentId === prevProps.documentId &&
      this.state.draft !== prevState.draft
    ) {
      //need to not reload the sidebar
      this.setState({ keepSidebarOnReload: true });
    }
    if (this.state.searchString !== prevState.searchString) {
      this.debounceSearch();
    }
    this.state.currentSearchMatch !== prevState.currentSearchMatch &&
      this.navigateMatches();

    if (this.state.showMine != prevState.showMine) {
      this.getDocumentSearchHistory(this.state.trackingId);
    }
    if (this.state.loading === false && prevState.loading === true && this.state.searchString) {
      this.debounceSearch()
    }
  }
  componentDidMount() {
    this.editSelected = PubSub.subscribe(EDIT_SELECTED, (msg, data) => {
      this.onEditSelected(data);
    });
    window.addEventListener("pagesinit", this.pdfPageInit);
    if (this.props.isDraft) {
      this.setState({ draft: true }, () => {
        this.getDocumentContent();
      });
    } else {
      this.getDocumentContent();
    }
    if (this.props.initialSearch) {
      this.setState({searchString:this.props.initialSearch})
    }
  }
  componentWillUnmount() {
    PubSub.unsubscribe(this.editSelected);
    this.setState({ setCustomFields: [] });
    window.removeEventListener("pagesinit", this.pdfPageInit);
  }

  scrollToBookmark = () => {
    if (this.props.bookmark) {
      let ctr = document.querySelector(
        `#contentframe-${this.state.internalDocument.contentRVO.id}`
      );
      if (ctr) {
        let el = ctr.querySelectorAll(
          'a[name="' + this.props.bookmark.replaceAll("#", "") + '"]',
          this.props.bookmark
        );
        el.length > 0 && el[0].scrollIntoView();
      }
    }
  };
  doDocumentSearch() {
    if (this.state.docType === "application/pdf") {
      //this.state.pdfFindFunction(this.state.searchString);
      this.setState({ PDFViewerSearchString: this.state.searchString });
    } else if (
      this.state.internalDocument &&
      !this.state.internalDocument.contentRVO.file
    ) {
      this.searchInternal();
    } else {
      this.searchHtml();
    }
  }
  debounceSearch() {
    if (this.searchDebounce) {
      window.clearTimeout(this.searchDebounce);
    }
    this.searchDebounce = window.setTimeout(() => {
      if (this.state.docType === "application/pdf") {
        //this.state.pdfFindFunction(this.state.searchString);
        this.setState({ PDFViewerSearchString: this.state.searchString });
      } else if (
        this.state.internalDocument &&
        !this.state.internalDocument.contentRVO.file
      ) {
        this.searchInternal();
      } else {
        this.searchHtml();
      }
      this.searchDebounce = null;
    }, 300);
  }
  getTemplate(name) {
    contentClient.get(`/template/${name}`).then((res) => {
      this.setState({ template: res.data });
    });
  }

  highlightDone(count) {
    this.setState({ searchMatches: count });
    this.setState({ currentSearchMatch: 0 });
    this.navigateMatches();
  }
  getPrevMatch() {
    let prevMatch;
    if (this.state.currentSearchMatch === 0) {
      prevMatch = this.state.searchMatches - 1;
    } else {
      prevMatch = this.state.currentSearchMatch - 1;
    }
    this.setState({ currentSearchMatch: prevMatch });
    if (this.state.docType === "application/pdf") {
      this.setState({ previousMatch: this.state.previousMatch + 1 });
      //this.state.pdfPreviousMatchFunction(this.state.searchString);
    }
  }
  getNextMatch() {
    let nextMatch;
    if (this.state.currentSearchMatch === this.state.searchMatches - 1) {
      nextMatch = 0;
    } else {
      nextMatch = this.state.currentSearchMatch + 1;
    }
    this.setState({ currentSearchMatch: nextMatch });
    if (this.state.docType === "application/pdf") {
      this.setState({ nextMatch: this.state.nextMatch + 1 });
      //this.state.pdfNextMatchFunction(this.state.searchString);
    }
  }
  getFirstMatch() {
    this.setState({ currentSearchMatch: 0 });
  }
  getLastMatch() {
    this.setState({ currentSearchMatch: this.state.searchMatches - 1 });
  }
  navigateMatches() {
    if (this.state.docType === "application/pdf") return;
    let el;
    let targetFrame;
    if (
      this.state.internalDocument &&
      !this.state.internalDocument.contentRVO.file
    ) {
      targetFrame = document.querySelector("#internalScrollContainer");
      el = document.querySelector(
        `#contentframe-${this.state.internalDocument.contentRVO.id}`
      );
    } else {
      targetFrame = document.querySelector(
        "iframe#documentframe-" + this.props.documentId
      );
      el = document.querySelector("#docCtr-" + this.props.documentId);
      if (targetFrame) {
        el = targetFrame.contentWindow.document;
      }
    }
    let selectedMark = el.querySelector("mark.selected");
    if (selectedMark) {
      selectedMark.classList.remove("selected");
      selectedMark.style.backgroundColor = "";
    }

    if (this.state.pdfMatches.length > 0) {
      let pdfMatch = this.state.pdfMatches[this.state.currentSearchMatch];
      if (pdfMatch) {
        this.state.pdfViewer.scrollPageIntoView({
          pageNumber: pdfMatch.sectionRef,
          destArray: [null, { name: "XYZ" }, 700, 0],
        });
      }
    }
    const marks = el.querySelectorAll("mark"); //first mark-ed element
    if (marks.length > this.state.currentSearchMatch) {
      let elem = marks[this.state.currentSearchMatch];
      elem.classList.add("selected");
      elem.style.backgroundColor = "orange";
      var y = elem.offsetTop;
      var x = elem.offsetLeft;
      let markElem = elem;
      elem.scrollIntoView({ block: "center", inline: "start" });
      // let scrollElem;
      // while ((elem = elem.offsetParent)) {
      //   if (elem.className.includes("mark-parent")) {
      //     scrollElem = elem;
      //     break;
      //   }
      //   y += elem.offsetTop;
      //   x += elem.offsetLeft;
      // }
      // if (
      //   this.state.internalDocument &&
      //   !this.state.internalDocument.contentRVO.file
      // ) {
      //   scrollElem
      //     ? scrollElem.scrollTo(0, y - 200)
      //     : targetFrame.scrollTo(0, y - 200);
      // } else {
      //   targetFrame.contentWindow
      //     ? targetFrame.contentWindow.scrollTo(0, y - 200)
      //     : el.scrollTo(0, y - 200);
      // }
    }
  }

  searchInternal() {
    const targetFrame = document.querySelector(
      `#contentframe-${this.state.internalDocument.contentRVO.id}`
    );
    let highlighter = new Mark(targetFrame);
    let options = {
      noMatch: this.noHighlightMatch,
      accuracy: "partially",
      separateWordSearch: false,
      acrossElements: true,
      each: this.addFragmentBookmark,
      filter: this.filterFragment,
      ignorePunctuation: [",", ".", ":", ";", "’"],
      done: this.highlightDone.bind(this),
    };
    highlighter.unmark();
    if (!!this.state.searchString.trim()) {
      highlighter.mark(this.state.searchString.trim(), options);
    }
  }

  searchHtml() {
    const targetFrame = document.querySelector(
      "iframe#documentframe-" + this.props.documentId
    );
    if (targetFrame) {
      let options = {
        accuracy: "partially",
        separateWordSearch: false,
        acrossElements: true,
        ignorePunctuation: [",", ".", ":", ";", "’"],
        done: this.highlightDone.bind(this),
      };
      const bodyEl = targetFrame.contentWindow.document.body;
  
      let highlighter = new Mark(bodyEl);
  
      highlighter.unmark();
      if (!!this.state.searchString.trim()) {
        highlighter.mark(this.state.searchString.trim(), options);
      }
    }
  }

  onDocumentLoadSuccess() {
    console.log("Loaded PDF document into the DocumentViewer");
  }
  onError() {
    console.log("Error loading PDF document into the DocumentViewer");
  }
  onCloseDiscussions() {
    console.log("Discussions Closed");
  }
  onPdfViewerMount = ({
    pdfFindFunction,
    pdfNextMatchFunction,
    pdfPreviousMatchFunction,
  }) => {
    this.setState({
      pdfFindFunction,
      pdfNextMatchFunction,
      pdfPreviousMatchFunction,
    });
  };
  onPdfSearchMatchesUpdate = ({ total, current }) => {
    this.setState({ searchMatches: total });
  };
  updateDocumentWorkflow = (revision) => {
    this.setState({
      internalDocument: { ...this.state.internalDocument, ...revision },
    });
  };
  render() {
    const { classes } = this.props;
    const template = this.state.template;
    let title = "";
    if (this.state.internalDocument) {
      title = this.state.internalDocument.contentRVO.title;
    }
    let externalDocUrl = `https://${window.location.hostname}:8081/document/${this.props.documentId}`
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "production") {
      externalDocUrl = `${window.location.protocol}//${window.location.hostname}`
      if (typeof window.location.port === "string" && window.location.port.length > 0) {
        externalDocUrl += ":" + window.location.port
      }
      externalDocUrl += `/document/${this.props.documentId}`
    }
    return (
      <div className={classes.pageContainer}>
        <Divider />
        <div className={classes.container}>
          <div className={classNames("pdf-hide", classes.sidebarContainer)}>
            {!this.props.removeSidebars &&
              (!this.state.loading || this.state.keepSidebarOnReload) && (
                <DocumentSidebar
                  workflowState={
                    this.state.internalDocument &&
                    this.state.internalDocument.workflowState
                  }
                  documentMeta={
                    this.state.documentMeta
                      ? this.state.documentMeta
                      : this.state.internalDocument
                  }
                  internalDocument={this.state.internalDocument}
                  updateDocumentWorkflow={this.updateDocumentWorkflow}
                  doWorkflow={this.doWorkflow}
                  doDiff={this.doDiff}
                  getDocumentContent={this.getDocumentContent}
                  edit={this.state.edit}
                  editContent={this.clickEditContent}
                  toggleDraft={this.toggleDraft}
                  onRevisionDiffChange={this.onRevisionDiffChange}
                  diffRevisionNumber={this.state.diffRevisionNumber}
                  diffRevisions={this.diffRevisions}
                  style={{ overflow: "hidden" }}
                  openFromPortlet={this.props.discussionId}
                  documentId={parseInt(this.props.documentId)}
                  searchId={this.props.searchId}
                  reset={this.reset}
                  onCloseDiscussions={this.onCloseDiscussions}
                  diffRecent={this.state.diffRecent}
                  isSearch={this.props.isSearch}
                  position={this.props.position}
                  score={this.props.score}
                  resolutions={this.props.resolutions}
                  updateResolvingReworks={this.onResolvingReworksChange}
                />
              )}
          </div>
          <SwipeableViews
            slideStyle={{ overflow: "hidden" }}
            index={this.state.selected}
            id="pages"
            style={{ overflow: "hidden", width: "100%" }}
            role="main"
          >
            <div
              className={
                this.state.internalDocument
                  ? classNames("mark-parent", classes.documentContainer)
                  : classNames(
                      "mark-parent",
                      classes.documentContainerNoOverflow
                    )
              }
              id="internalScrollContainer"
            >
              {this.state.loading && (
                <LinearProgress color="secondary" variant="indeterminate" />
              )}
              <div
                className={classNames(classes.downloadedCover, {
                  [classes.showDownloadCover]: this.state.downloadedOriginal,
                })}
                role="dialog"
              >
                <IconButton
                  onClick={() => this.setState({ downloadedOriginal: false })}
                  style={{ position: "absolute", top: 0, right: 0 }}
                >
                  <CloseIcon />
                </IconButton>
                <Typography variant="h5">
                  {this.props.t("file_downloaded_header")}
                </Typography>
                <Typography variant="subtitle" style={{ marginTop: 30 }}>
                  {this.props.t("file_downloaded_subheader")}
                </Typography>
                <Button
                  onClick={() => this.setState({ downloadedOriginal: false })}
                  style={{ marginTop: 30 }}
                  variant="outlined"
                >
                  {this.props.t("file_downloaded_return_button")}
                </Button>
              </div>
              {this.state.showRevalMessage && (
                <div style={{ margin: 30 }}>
                  <Alert severity="warning">
                    {this.props.t("document_passed_revalidation")}
                  </Alert>
                </div>
              )}
              {this.state.error ? (
                <div style={{ margin: 30 }}>
                  <Alert severity="error">
                    {this.state.forbidden
                      ? this.props.t(
                          "document_viewer_cannot_view_document_forbidden"
                        )
                      : this.props.t("document_viewer_error_occurred")}
                  </Alert>
                </div>
              ) : (
                <>
                  {!this.state.internalDocument ? (
                    <>
                      {this.state.docType === "application/pdf" ? (
                        <PDFViewer
                          data={this.state.docContent}
                          onMount={this.onPdfViewerMount}
                          onSearchMatchesUpdate={this.onPdfSearchMatchesUpdate}
                          onLoaded={() => this.setState({ loading: false })}
                          isSearch={this.props.isSearch}
                          searchString={this.state.PDFViewerSearchString}
                          previousMatch={this.state.previousMatch}
                          nextMatch={this.state.nextMatch}
                        />
                      // ) : this.props.isSearch ? (
                      //   <div id="overlay">
                      //     <iframe
                      //       id={"documentframe-" + this.props.documentId}
                      //       className={classes.iframe}
                      //       style={
                      //         !this.props.fullscreen && this.props.portlet
                      //           ? { height: 312 }
                      //           : { height: 700 }
                      //       }
                      //       csp={ this.state.documentMeta ? `base-uri self ${this.state.documentMeta.documentRVO.documentURL}` : `base-uri self `}
                      //       srcDoc={this.state.docContent}
                      //       sandbox="allow-forms allow-pointer-lock allow-popups allow-modals allow-same-origin allow-scripts"
                      //     />
                      //   </div>
                      ) : (
                        <div
                          id="overlay"
                          style={{
                            width: "100%",
                            height: this.state.showRevalMessage
                              ? "88%"
                              : "100%",
                          }}
                        >
                          <iframe
                            onLoad={(e) => {
                              this.state.docContent !== "" &&
                                this.setState({
                                  loading: false,
                                })
                            }}
                            style={{ width: "100%", height: "100%" }}
                            id={"documentframe-" + this.props.documentId}
                            frameBorder="0"
                            // csp={this.state.documentMeta ? `script-src 'nonce-${this.state.nonce}';` : `base-uri self `}
                            // srcDoc={this.state.docContent}
                            src={externalDocUrl}
                            sandbox="allow-forms allow-pointer-lock allow-popups allow-modals allow-same-origin allow-scripts"
                          />
                        </div>
                      )}
                    </>
                  ) : !this.state.edit ? (
                    <div style={{ height: "100%" }} id="internalDocContainer">
                      {this.state.diff ? (
                        <DiffRevisions
                          template={this.state.internalDocument.templateRVO}
                          hasDraft={this.state.internalDocument.hasDraft}
                          draft={this.state.draft}
                          toggleDraft={this.toggleDraft}
                          title={title}
                          currentRevision={this.state.internalDocument}
                          diffRevisionNumber={this.state.diffRevisionNumber}
                        />
                      ) : (
                        <DisplayTemplate
                          customFields={this.state.customFields}
                          searchString={this.state.PDFViewerSearchString}
                          isNotTemplate
                          noHeader={this.props.noHeader}
                          shouldDownloadOriginal={
                            this.state.shouldDownloadOriginal
                          }
                          isSearch={this.props.isSearch}
                          editTemplate={this.edit}
                          template={this.state.internalDocument.templateRVO}
                          hasDraft={this.state.internalDocument.hasDraft}
                          hasLive={this.state.internalDocument.hasLive}
                          currentRevision={this.state.internalDocument}
                          draft={this.state.draft}
                          toggleDraft={this.toggleDraft}
                          title={title}
                          onMount={this.onPdfViewerMount}
                          onSearchMatchesUpdate={this.onPdfSearchMatchesUpdate}
                          onLoaded={() => {
                            this.props.bookmark && this.scrollToBookmark();
                            this.setState({
                              loading: false,
                              keepSidebarOnReload: false,
                            });
                          }}
                          loading={this.state.loading}
                          documentId={this.props.documentId}
                          previousMatch={this.state.previousMatch}
                          nextMatch={this.state.nextMatch}
                        />
                      )}
                    </div>
                  ) : (
                    <div
                      style={{
                        flexDirection: "row",
                        display: "flex",
                        height: "100%",
                      }}
                    >
                      <CreateContentFlow
                        edit
                        createRevision
                        onClose={this.edit}
                        onRevisionAdded={this.submitEdit}
                        onSubmit={this.submitEdit}
                        sections={
                          this.state.internalDocument.sectionRVOs
                            ? this.state.internalDocument.sectionRVOs
                            : []
                        }
                        content={this.state.internalDocument.contentRVO}
                        template={this.state.internalDocument.templateRVO}
                        resolvingReworks={this.state.resolvingReworks}
                      />
                    </div>
                  )}
                </>
              )}
            </div>
          </SwipeableViews>
          {/* {this.props.isSearch &&  */}
          <div
            className={classNames("pdf-hide", classes.fragmentContainer)}
            role="complementary"
          >
            {!this.props.removeSidebars && (
              <>
                <Typography component="h2" className={classes.srOnly}>
                  {this.props.t("document_search_sidebar_header")}
                </Typography>
                <Drawer
                  variant="permanent"
                  className={classNames(classes.drawer, {
                    [classes.drawerOpen]: this.state.sidebarOpen,
                    [classes.drawerClose]: !this.state.sidebarOpen,
                  })}
                  classes={{
                    paper: classNames({
                      [classes.drawerOpen]: this.state.sidebarOpen,
                      [classes.drawerClose]: !this.state.sidebarOpen,
                    }),
                    paperAnchorLeft: null,
                  }}
                  open={this.state.sidebarOpen}
                >
                  <div
                    style={{ height: this.props.isSearch ? 700 : "100%" }}
                    className={classes.sidebarContainer}
                  >
                    <div className={classes.drawerHeader}>
                      <IconButton
                        onClick={this.toggleSidebar}
                        className={classes.sidebarIcon}
                        aria-label="Close search sidebar"
                      >
                        {this.state.sidebarOpen ? (
                          <ChevronRightIcon />
                        ) : (
                          <ChevronLeftIcon />
                        )}
                      </IconButton>
                    </div>
                    <div id="sidebarContent">
                      {(this.state.documentMeta ||
                        (this.state.internalDocument &&
                          this.state.internalDocument.contentRVO.file)) && (
                        <div style={{ textAlign: "center" }}>
                          <FormControl component="fieldset">
                            <FormLabel component="legend">
                              {this.props.t("document_display_as")}
                            </FormLabel>
                            <Typography component="div">
                              <Grid
                                component="label"
                                container
                                alignItems="center"
                                spacing={1}
                              >
                                <Grid item>
                                  <Trans i18nKey="global_html" />
                                </Grid>
                                <Grid item>
                                  <Switch
                                    color="default"
                                    aria-label={
                                      this.state.displayAs === "pdf"
                                        ? "View in HTML format"
                                        : "View in PDF format"
                                    }
                                    checked={
                                      this.state.displayAs === "pdf" &&
                                      this.canDisplayPdf()
                                    }
                                    disabled={
                                      !this.canDisplayHtml() ||
                                      !this.canDisplayPdf()
                                    }
                                    onChange={(e) => {
                                      this.setState(
                                        {
                                          displayAs: e.target.checked
                                            ? "pdf"
                                            : "html",
                                        },
                                        () => this.getDocumentContent()
                                      );
                                    }}
                                    name="displayas"
                                  />
                                </Grid>
                                <Grid item>
                                  <Trans i18nKey="global_pdf" />
                                </Grid>
                              </Grid>
                            </Typography>
                          </FormControl>
                        </div>
                      )}
                      <span>
                        <KpsTextField
                          id="search-document"
                          label="Search Document"
                          type="search"
                          className={classes.textField}
                          margin="normal"
                          variant="outlined"
                          value={this.state.searchString}
                          onChange={this.handleChange("searchString")}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <IconButton aria-label="Search">
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </span>
                      {this.state.searchMatches > 0 && (
                        <div className={classes.matchToolbar}>
                          {this.state.docType !== "application/pdf" && (
                            <IconButton
                              onClick={this.getFirstMatch}
                              className={classes.button}
                              aria-label="First match"
                            >
                              <FirstPageIcon />
                            </IconButton>
                          )}
                          <IconButton
                            onClick={this.getPrevMatch}
                            className={classes.button}
                            aria-label="Previous match"
                          >
                            <ChevronLeftIcon />
                          </IconButton>
                          <span className={classes.noSelectSpan}>
                            {this.state.currentSearchMatch + 1} /{" "}
                            {this.state.searchMatches}
                          </span>
                          <IconButton
                            onClick={this.getNextMatch}
                            aria-label="Next match"
                            className={classes.button}
                          >
                            <ChevronRightIcon />
                          </IconButton>
                          {this.state.docType !== "application/pdf" && (
                            <IconButton
                              onClick={this.getLastMatch}
                              aria-label="Last match"
                              className={classes.button}
                            >
                              <LastPageIcon />
                            </IconButton>
                          )}
                        </div>
                      )}
                      {this.state.historymessage && (
                        <Accordion
                          key="searchHistory"
                          className={classes.expansionPanel}
                          expanded={
                            this.state.expandedMatchPanel === "searchHistory"
                          }
                          onChange={this.handlePanelChange("searchHistory")}
                        >
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Badge
                              className={classes.margin}
                              showZero
                              badgeContent={this.state.historymessagecount}
                              color={
                                this.state.historymessagecount > 0
                                  ? "secondary"
                                  : "primary"
                              }
                            />
                            <Typography
                              className={classes.heading}
                              component="h3"
                            >
                              {this.state.matchedHeader}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails
                            classes={{ root: classes.expansionPanel }}
                          >
                            <div className={classes.searchHistoryControl}>
                              <RadioGroup
                                aria-label="previous search matches"
                                name="prevMatches"
                                className={classes.radioGroup}
                                value={this.state.showMine}
                                onChange={() =>
                                  this.setState((prev) => ({
                                    showMine: !prev.showMine,
                                  }))
                                }
                              >
                                <FormControlLabel
                                  value={true}
                                  control={<Radio color="primary" />}
                                  label="By Me"
                                  labelPlacement="end"
                                />
                                <FormControlLabel
                                  value={false}
                                  control={<Radio color="primary" />}
                                  label="By Other Users"
                                  labelPlacement="end"
                                />
                              </RadioGroup>
                            </div>
                            {this.state.historymessage.map((search, idx) => {
                              return (
                                <div key={"dochist-" + idx}>
                                  <ListItemLink
                                    onClick={() =>
                                      this.handleSearchHistoryClick(search)
                                    }
                                  >
                                    <ListItemText
                                      primary={search.searchString}
                                      secondary={
                                        search.timesUsed > 0
                                          ? "Last Viewed : " +
                                            moment(search.lastDate).format(
                                              "DD/MM/YYYY HH:mm:ss"
                                            ) +
                                            " Viewed: " +
                                            search.timesViewed +
                                            " Used: " +
                                            search.timesUsed
                                          : "Last Viewed : " +
                                            moment(search.lastDate).format(
                                              "DD/MM/YYYY HH:mm:ss"
                                            ) +
                                            " Viewed: " +
                                            search.timesViewed
                                      }
                                    />
                                  </ListItemLink>
                                  <Divider />
                                </div>
                              );
                            })}
                          </AccordionDetails>
                        </Accordion>
                      )}
                      {this.props.fragments &&
                        this.props.fragments.length > 0 && (
                          <Accordion
                            key="fragments"
                            className={classes.expansionPanel}
                            expanded={
                              this.state.expandedMatchPanel === "fragments"
                            }
                            onChange={this.handlePanelChange("fragments")}
                          >
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Badge
                                showZero
                                className={classes.margin}
                                badgeContent={
                                  this.props.fragments.filter((f) => !!f).length
                                }
                                color="secondary"
                              />
                              <Typography
                                className={classes.heading}
                                component="h3"
                              >
                                <Trans i18nKey="document_viewer_best_matches" />
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails
                              classes={{ root: classes.expansionPanel }}
                              id="fragments-list"
                            >
                              {this.props.fragments.filter((f) => !!f)
                                .length === 0 ? (
                                <Typography
                                  style={{
                                    textAlign: "center",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <Trans i18nKey="no_matches_found" />
                                </Typography>
                              ) : (
                                <>
                                  {this.props.fragments
                                    .filter((f) => !!f)
                                    .map((fragment, idx) => {
                                      //if (fragment.score > 0) {
                                      return (
                                        <div key={idx}>
                                          <ListItemLink
                                            onClick={() =>
                                              this.handleFragmentClick(fragment)
                                            }
                                          >
                                            <ListItemText>
                                              {" "}
                                              <div
                                                dangerouslySetInnerHTML={this.getInnerHtml(
                                                  fragment
                                                )}
                                              />
                                            </ListItemText>
                                          </ListItemLink>
                                          <Divider />
                                        </div>
                                      );
                                      //}
                                    })}
                                </>
                              )}
                            </AccordionDetails>
                          </Accordion>
                        )}
                    </div>
                  </div>
                </Drawer>
              </>
            )}
          </div>
          {/* } */}
        </div>
      </div>
    );
  }

  canDisplayHtml = () => {
    if (this.state.documentMeta) {
      return this.state.documentMeta.canDisplayHtml;
    }
    return (
      this.state.internalDocument &&
      this.state.internalDocument.contentRVO.file &&
      this.state.internalDocument.contentRVO.file.canDisplayHtml
    );
  };
  canDisplayPdf = () => {
    if (this.state.documentMeta) {
      return this.state.documentMeta.canDisplayPdf;
    }
    return (
      this.state.internalDocument &&
      this.state.internalDocument.contentRVO.file &&
      this.state.internalDocument.contentRVO.file.canDisplayPdf
    );
  };
  onEditSelected = (selected) => {
    this.setState({ editRevision: selected });
  };
  updateSection(section) {
    let sections = this.state.internalDocument.sectionRVOs.splice(0);
    for (let i = 0; i < sections.length; i++) {
      if (sections[i].sectionID === section.sectionID) {
        sections[i] = section;
      }
    }
    this.setState({
      internalDocument: {
        ...this.state.internalDocument,
        sectionRVOs: sections,
      },
    });
  }

  reset = () => {
    this.setState({ diff: false, diffRecent: false, diffNodes: [] });
  };

  onResolvingReworksChange = (resolvingReworks) => {
    this.setState({ resolvingReworks });
  };

  edit = () => {
    this.setState({ edit: !this.state.edit, sidebarOpen: false });
  };

  submitEdit = (rev) => {
    this.setState({ edit: !this.state.edit, sidebarOpen: false });
    this.getDocumentContent();
  };

  toggleDraft = () => {
    this.setState({ draft: !this.state.draft }, () => {
      this.getDocumentContent();
    });
  };

  onRevisionDiffChange = (revision) => {
    this.setState({ diffRevisionNumber: revision.revisionNumber });
  };

  diffRevisions = () => {
    this.setState({ diff: !this.state.diff });
  };

  doWorkflow = () => {
    if (!this.state.draft && this.state.internalDocument.hasDraft) {
      this.setState({ draft: true }, () => {
        this.getDocumentContent();
      });
    }
  };

  doDiff = () => {
    this.setState({ diff: true });
  };

  clickEditContent = () => {
    contentClient
      .get(`/knowledgeitem/document/${this.props.documentId}`)
      .then((res) => {
        this.setState({ contentRevision: res.data });
        this.getTemplate(res.data.layout);
      });
  };
  toggleSidebar = () => {
    this.setState((prev) => ({ sidebarOpen: !prev.sidebarOpen }));
  };
  handleChange = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
    prop === "searchString" &&
      this.setState({ searchMatches: 0, currentSearchMatch: 0 });
  };
  handlePanelChange = (panel) => (event, expanded) => {
    this.setState({ expandedMatchPanel: expanded ? panel : false });
  };
  handleFragmentClick = (fragment) => {
    let regex = /(<([^>]+)>)/gi;
    // let searchText = fragment.text.replace(regex, "").trim();
    let searchText = fragment.replace(regex, "").trim();
    this.setState({ searchString: searchText });
    this.setState({ searchMatches: 0 });
  };
  handleSearchHistoryClick = (search) => {
    let regex = /(<([^>]+)>)/gi;
    let searchText = search.searchString.replace(regex, "").trim();
    this.setState({ searchString: searchText });
    this.setState({ searchMatches: 0 });
  };
  addFragmentBookmark = (elem) => {
    // const targetFrame = document.querySelector('iframe#documentframe-' + this.props.documentId);
    // let winEl = window;
    // if (targetFrame) {
    //   winEl = targetFrame.contentWindow;
    // }
    // if (this.state.searchMatches === 0) {
    //   //go to the first match
    //   //winEl.scrollTo(0,this.offset(elem));
    // }
    // let sMatches = this.state.searchMatches ? this.state.searchMatches + 1 : 1;
    // this.setState({searchMatches: sMatches});
  };
  offset = (elem) => {
    if (!elem) elem = this;
    let ht = elem.offsetHeight;

    var y = elem.offsetTop;

    while ((elem = elem.offsetParent)) {
      y += elem.offsetTop;
    }
    return y;
  };
  filterFragment = (node, term, termCounter, allCounter) => {
    let a = term,
      b = termCounter,
      c = allCounter;
    return true;
  };
  noHighlightMatch = (terms) => {
    if (window.find) {
      //window.find(terms);
    }
  };
  getInnerHtml(text) {
    return { __html: text };
  }

  isResponseFromCache = (url) => {
    // if request has taken longer than this, it's not from the cache 
    let request_duration_limit_ms = 10;
    let result = false;
    let entries = window.performance.getEntriesByName(url);
    
    let lastEntry = entries.length - 1;
    if(lastEntry>-1){
      let entry = entries[lastEntry];
      if(entry.responseStart - entry.requestStart <= request_duration_limit_ms){
        result = true;
      }
    }
    return result;
  };
  getDocumentContent = () => {
    this.setState({
      loading: true,
      searchMatches: 0,
      currentSearchMatch: 0,
      error: false,
      forbidden: false,
    });

    let documentUrl = `/document/${this.props.documentId}/content`
    
    axios
      .get(documentUrl, {
        params: {
          locale: "en_GB",
          displayDraft: this.state.draft,
          searchId: this.props.searchId,
          position: this.props.position,
          score: this.props.score,
          selectedFormat: this.state.displayAs,
        },
      })
      .then((res) => {
        let isFromCache=this.isResponseFromCache(documentUrl);
        this.setState({
          showRevalMessage:
            res.data.documentRVO.revalidationBehaviour ===
              SHOW_REVALIDATION_WARNING &&
            !!res.data.documentRVO.revalidationDate &&
            moment(res.data.documentRVO.revalidationDate).isSameOrBefore(
              moment()
            ),
        });
        if (parseInt(this.props.documentId) === res.data.documentID) {
          // EXTERNAL document
          this.setState({ documentMeta: res.data }, () => {
            if (!this.canDisplayPdf()) {
              this.setState({ displayAs: "html" });
            }
          });
          if (this.state.trackingId !== res.data.trackingID) {
            this.getDocumentSearchHistory(res.data.trackingID);
            this.setState({ trackingId: res.data.trackingID });
          }
          this.setState({ docType: res.data.contentType });
          this.possiblyDownloadOriginal(res.data.documentRVO.contentType);
          if (res.data.contentType === "application/pdf") {
            this.setState({
              docContent: this.base64ToArrayBuffer(res.data.byteString),
            });
          } else {
            // for detail see https://kpsolutions.atlassian.net/wiki/x/AQAxTg
            // if the document is from the browser cache, there is the option of setting headers to avoid it
            console.log("Is document from cache?: " + isFromCache);
            this.setState({
              docContent: this.base64ToArrayBuffer(res.data.byteString),
              nonce: res.data.nonce,
            });
          }
          this.props.isExternalDocument && this.props.isExternalDocument();
          if (
            res.data.contentRVO &&
            res.data.contentRVO.file.failedToGetContent
          ) {
            this.setState({ error: true });
          }
        } else {
          // KNOWLEDGE ITEM
          let diff = false;
          if (
            this.props.history.location.state &&
            this.props.history.location.state.showDiff
          ) {
            this.setState({ diff: true, diffRecent: true });
            diff = true;
          }
          if (diff) {
            this.setState({
              diffRevisionNumber: res.data.contentRVO.revisionNumber - 1,
            });
          }
          if (res.data.contentRVO.file) {
            this.setState({
              docType: res.data.contentRVO.file.contentType,
            });
          }
          this.setState(
            {
              internalDocument: res.data,
              setCustomFields: res.data.customFieldsDTOS,
              customFields: res.data.customFieldsDTOS,
              draft: res.data.contentRVO.draft,
            },
            () => {
              if (res.data.contentRVO.file) {
                this.possiblyDownloadOriginal(
                  res.data.contentRVO.file.originalContentType
                );
              }
            }
          );
        }
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 403) {
          this.setState({ forbidden: true });
        }
        this.setState({ loading: false, error: true });
      });
  };

  shouldDownloadOriginal = (contentType) => {
    return (
      (isExcelMime(contentType) &&
        this.props.properties[PropertyNames.AUTO_DOWNLOAD_EXCEL] === "true") ||
      (isWordMime(contentType) &&
        this.props.properties[PropertyNames.AUTO_DOWNLOAD_WORD] === "true") ||
      (isPptMime(contentType) &&
        this.props.properties[PropertyNames.AUTO_DOWNLOAD_PPT] === "true")
    );
  };

  possiblyDownloadOriginal = (contentType) => {
    if (this.shouldDownloadOriginal(contentType)) {
      this.setState({ downloadedOriginal: true });
      let url = `/document/${this.props.documentId}/original`;
      if (
        this.state.internalDocument &&
        this.state.internalDocument.contentRVO.fileId
      ) {
        url = `/document/file/${
          this.state.internalDocument.contentRVO.fileId
        }?selectedFormat=original`;
      }
      axios
        .get(url)
        .then((res) => {
          let blob = new Blob();
          blob = new Blob([this.base64ToArrayBuffer(res.data.byteString)], {
            type: res.data.contentType,
          });
          const objectURL = URL.createObjectURL(blob);
          var link = document.createElement("a");
          link.href = objectURL;
          link.download = res.data.fileName;
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(objectURL);
          document.body.removeChild(link);
        })
        .catch((err) => {
          this.props.enqueueSnackbar(this.props.t("error_occurred_generic"), {
            variant: "error",
          });
        });
    }
  };

  base64ToArrayBuffer = (base64) => {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    let uint16 = new Uint16Array(
      bytes.buffer,
      bytes.buffer.byteOffset,
      bytes.buffer.byteLength / Uint16Array.BYTES_PER_ELEMENT
    );
    let result = uint16.buffer;

    return result;
  };

  getDocumentSearchHistory = (trackingId) => {
    axios
      .get(`/document/${this.props.documentId}/history`, {
        params: {
          myEvents: this.state.showMine,
        },
      })
      .then((res) => {
        let hdr = this.state.showMine
          ? "Viewed from Your Searches"
          : "Viewed from Other Users Searches";
        this.setState({
          historymessage: res.data,
          historymessagecount: res.data.length,
          matchedHeader: hdr,
        });
      });
  };
}
const mapStateToProps = (state) => ({
  apiLocation: state.setting.apiLocation,
  filters: state.search.filters,
  properties: state.setting.applicationProperties,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {
  setCustomFields,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles)(withTranslation()(withSnackbar(DocumentViewer)))
  )
);
